import PropTypes from 'prop-types'
import messages from '../../messages'
import { SelectionModal } from '../SelectionModal/SelectionModal'

export const PlaybackRateModal = ({
  playbackRateOptions,
  playbackRate,
  setPlaybackRate,
  onRequestClose,
  rightOffset = 0,
  dropUp,
}) => (
  <SelectionModal
    activeIndex={playbackRateOptions.findIndex(({ value }) => value === playbackRate)}
    onOptionIndexChosen={(index) => setPlaybackRate(playbackRateOptions[index].value)}
    options={playbackRateOptions}
    onRequestClose={onRequestClose}
    rightOffset={rightOffset}
    dropUp={dropUp}
    titleMsg={messages.playbackRateTitle}
  />
)

PlaybackRateModal.propTypes = {
  /** List of available playback rates */
  playbackRateOptions: PropTypes.array.isRequired,
  /** The current playback rate */
  playbackRate: PropTypes.number.isRequired,
  /** Function to update playback rate */
  setPlaybackRate: PropTypes.func.isRequired,
  /** Function close the modal (after selection) */
  onRequestClose: PropTypes.func.isRequired,
  /** Additional right offset to the modal position */
  rightOffset: PropTypes.number,
  /** Open the modal above the button rather than below it */
  dropUp: PropTypes.bool,
}
